module.exports = __webpack_public_path__ + "static/media/pax.d1c69a54c75a0bc15b8e9ee50578331f.svg";